"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmsOptOut_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SmsOptOut_Factory = /** @class */ (function () {
    function SmsOptOut_Factory() {
    }
    SmsOptOut_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            PhoneNum: model.PhoneNum,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
        };
        return result;
    };
    SmsOptOut_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            PhoneNum: model.PhoneNum,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
        };
        return result;
    };
    return SmsOptOut_Factory;
}());
exports.SmsOptOut_Factory = SmsOptOut_Factory;
